export const WITHDRAWAL_REQUEST_PLATFORM_ENUM = {
    CARD: 'CARD',
    CRYPTO: 'CRYPTO',
    CASH: 'CASH',
};
